import { render, staticRenderFns } from "./OldmanLeave.vue?vue&type=template&id=179f2275&scoped=true"
import script from "./OldmanLeave.vue?vue&type=script&lang=js"
export * from "./OldmanLeave.vue?vue&type=script&lang=js"
import style0 from "./OldmanLeave.vue?vue&type=style&index=0&id=179f2275&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179f2275",
  null
  
)

export default component.exports